import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { LoaderCircle } from 'lucide-react';

const Logout = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    logout({ logoutParams: { returnTo: window.location.origin + '/login' } });
  }, [logout]);

  return <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-brand-midnight"><LoaderCircle className="h-6 w-6 animate-spin" /><p className="font-semibold">Signing you out securely...</p><p className="text-sm text-gray-500">You will return to the sign-in page.</p></div>;
};

export default Logout;
